import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface AddProductRequest {
  productCode: string;
  productName: string;
  productGroupId: number | string;
  salePrice: number | string;
  buyingPrice?: number | null;
  taxRateId: number | string;
  unit: number | string;
  merchantId?: number;
  currencyCode?: string;
  isOpenPrice: boolean;
  barcode?: string | null;
  status: "BLOCKED" | "ACTIVE" | "PASSIVE";
  productGroupName?: string | null;
  productUnitName?: string | null;
  productUnitShortCode?: string | null;
}

export type AddProductResponse = BaseResponse<null>;

async function addProduct(
  data: AddProductRequest
): Promise<AddProductResponse> {
  try {
    const apiData = {
      ...data,
      productGroupId: typeof data.productGroupId === 'string' ? parseInt(data.productGroupId) || 0 : data.productGroupId,
      salePrice: typeof data.salePrice === 'string' ? parseFloat(data.salePrice) || 0 : data.salePrice,
      taxRateId: typeof data.taxRateId === 'string' ? parseInt(data.taxRateId) || 0 : data.taxRateId,
      unit: typeof data.unit === 'string' ? parseInt(data.unit) || 0 : data.unit,
    };
    
    return (await axiosInstance.post("/Product/AddProduct", apiData)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddProduct() {
  return useMutation<AddProductResponse, Error, AddProductRequest>(
    (variables) => addProduct(variables)
  );
}
